export const ENTRADA = 'E'
export const SALIDA = 'S'
